<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Recode</div>
                <div class="child-w-80">
                  <input v-model="searchParams.recode" type="text" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Khách sạn</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.hotelIdList"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Công ty/ Đại lý</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.agentId"
                    clearable
                    filterable
                    collapse-tags
                  >
                    <el-option
                      v-for="(item, index) in agentOptions"
                      :key="index"
                      :value="item.id"
                      :label="`(${item.code}) ${item.name || ''}`"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Hạng phòng</div>
                <div class="child-w-80">
                  <el-select v-model="searchParams.roomLevelId" clearable>
                    <el-option
                      v-for="(roomLevel, index) in roomLevelList"
                      :key="index"
                      :value="roomLevel.id"
                      :label="roomLevel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Từ ngày</div>
                <div class="child-w-80">
                  <CalendarRange
                    v-model="datetimeRange"
                    style="display: block; width: 500px"
                    mode="date"
                    @input="setDateRange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">Báo cáo checkout</span>
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div v-loading="loading" class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              dom-layout="scroll"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              :auto-select-first-row="false"
              :auto-size-cell="true"
              row-selection="false"
            />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Mã đặt phòng: Mã đặt phòng</li>
            <li>Nguồn: nguồn của đặt phòng</li>
            <li>Hạng phòng: hiển thị tên hàng phòng và số phòng</li>
            <li>Ngày đến: ngày đến của đặt phòng</li>
            <li>Ngày đi: ngày đi của đặt phòng</li>
            <li>
              Số đêm: Số đêm được tính từ ngày khách đến đến ngày khách đi
            </li>
            <li>Số khách: số khách của đặt phòng</li>
            <li>Tên khách: Tên khách đặt phòng</li>
            <li>Số điện thoại khách: số điện thoại của khách đặt phòng</li>
            <li>
              Doanh thu sau khi giảm giá: Doanh thu phòng + Phí dịch vụ - Giảm
              giá
            </li>
            <li>Thanh toán: số tiền khách đã Thanh toán</li>
            <li>
              Số dư: Doanh thu sau khi giảm giá - thanh toán. Hoặc số tiền sau
              khi đã được chuyển sang công nợ
            </li>
            <li>
              Hiển thị tổng số phòng, Khách, doanh thu: tổng của các ngày trong
              khoảng thời gian tìm kiếm
            </li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import { getAllHotel } from '@/api/hotel'
import { getListRoomLevelApi } from '@/api/Room/roomLevel'
import { getAgentListForReport } from '@/api/report_service/takeMoneybyInvoice'
import { getCheckoutList } from '@/api/report_service/checkoutReport'
import InfoBtn from './components/InfoBtn.vue'

export default {
  components: {
    SelectWithSearchTable,
    InfoBtn,
    CalendarRange
  },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        wrapText: true,
        autoHeight: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      defaultDatetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      datetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      dialogFormVisible: false,
      hotelList: [],
      loading: false,
      searchParams: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        hotelIdList: [],
        agentId: null,
        roomLevelId: null,
        recode: null
      },
      defaultSearchParams: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        hotelIdList: [],
        agentId: null,
        roomLevelId: null,
        recode: null
      },
      sourceOptions: [],
      roomLevelList: [],
      columnsSource: [
        {
          headerName: 'Mã nguồn',
          field: 'code',
          width: 100
        },
        {
          headerName: 'Mô tả',
          field: 'desc'
        }
      ],
      agentOptions: [],

      columns: [
        {
          headerName: this.$t('grid.column.bookingCode'),
          field: 'recode',
          tooltipField: 'recode',

          // cellClass: "grid-cell-centered",
          sortable: false,
          minWidth: 120,
          maxWidth: 160
        },
        {
          headerName: this.$t('grid.column.source'),
          field: 'source',
          tooltipField: 'source',
          flex: 1,

          // cellClass: "grid-cell-centered",
          // width: 100,
          minWidth: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.roomLevel'),
          field: 'roomLevel',
          tooltipField: 'roomLevel',
          flex: 1,
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 120,
          cellStyle: params => {
            if (params.node.lastChild) {
              return {
                display: 'flex',
                'align-items': 'center',
                'text-wrap': 'nowrap',
                'font-weight': 600,
                overflow: 'visible'
                // background: 'red'
              }
            }
          },
          flex: 1
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.arrivalDate'),
          field: 'arriveDate',

          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 140,
          maxWidth: 140
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.departureDate'),
          field: 'departDate',

          minWidth: 140,
          maxWidth: 140,
          // cellRenderer: 'CellRenderTextInput',
          sortable: false
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.numNight'),
          field: 'numOfNight',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 70,
          maxWidth: 80
          // cellClass: "grid-cell-centered",
        },

        {
          headerName: this.$t('grid.column.numGuest'),
          field: 'numOfGuest',

          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 120,
          maxWidth: 120,
          cellStyle: params => {
            if (params.node.lastChild) {
              return {
                display: 'flex',
                'align-items': 'center',
                'text-wrap': 'nowrap',
                'font-weight': 600,
                overflow: 'visible'
                // background: 'red'
              }
            }
          }
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.customerName'),
          field: 'guestName',
          tooltipField: 'guestName',
          flex: 1,
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 120
          // cellClass: "grid-cell-centered",
        }
      ],
      rows: []
    }
  },
  created() {
    this.getListHotel()
    this.fnGetAgentOptions()
    this.getRoomLevelOptions()
  },
  mounted() {
    this.attachData()
  },
  methods: {
    handleCommand(cmmd) {
      this.$message('click on item ' + cmmd)
    },
    setDateRange(range) {
      // console.log(range.start, range.end)

      this.searchParams.dateFrom = range.start
      this.searchParams.dateTo = range.end
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    async getRoomLevelOptions() {
      const data = await getListRoomLevelApi()
      this.roomLevelList = data?.data || []
      // await getRoom()
    },
    async fnGetAgentOptions() {
      const data = await getAgentListForReport()
      this.agentOptions = [{ id: null, code: 'Tất cả' }, ...data.data] || []
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 30
      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    async attachData() {
      // this.loading = true

      const data = await getCheckoutList(this.searchParams)
      // this.loading = false
      if (data.data?.infoList.length > 0) {
        this.rows = [
          ...data.data?.infoList,
          {
            roomLevel: `Tổng: ${data.data.totalRoom} phòng`,
            numOfGuest: `Tổng: ${data.data.totalGuest} khách`,
            revenueAfterDiscount: `Tổng:  ${Number(
              data.data.totalRevenue
            ).toLocaleString('en')}`,
            rowHeightTotal: true
          }
        ]
      } else {
        this.rows = []
      }
      // this.rows = data.data
    },
    onSearch() {
      this.attachData()
    },
    onReset() {
      this.searchParams = { ...this.defaultSearchParams }
      this.datetimeRange = { ...this.defaultDatetimeRange }
      this.attachData()
    }
  }
}
</script>

<style lang="scss">
.button-containers-title {
  display: flex;
  /* margin-top: 20px; */
  justify-content: flex-end;
  align-items: flex-end;
  gap: 10px;
  .download-button {
    padding: 10px 10px;
  }
}
.ag-cell-wrapper {
  top: auto !important;
}
</style>
